<div class="container-fluid top-nav pt-1">
        <div class="row mt-2 ml-0 pl-0 pr-0 mr-0">
            <div class="col pl-0 pr-0">
              <div class="card p-3">
                <app-person [modal]="false" [update]="saveperson"></app-person>
              </div>
            </div>
          </div>   
          <div class="card mt-3 p-3">
            <div class="row">
              <div class="col-3 col-sm-2 col-md text-center p-1">
                <app-refreshauth></app-refreshauth>
              </div>
              <div class="col-3 col-sm-2 col-md text-center p-1">
                <a class="cursor-pointer opacity" matTooltip="{{ 'useraccount.editinformation' | trans }}" matTooltipPosition="above" 
                data-toggle="modal" data-target="#personeditmodal">
                  <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
                    create
                    </span>
                    <p class="mb-0 pt-1 f-13">{{ 'useraccount.editinformation' | trans }}</p>
                </a>
              </div>
              <div class="col-3 col-sm-2 col-md text-center p-1">
                <a class="cursor-pointer opacity" matTooltip="{{ 'useraccount.managephoto' | trans }}"
                 matTooltipPosition="above" data-toggle="modal" data-target="#personphotomodal">
                  <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
                    perm_media
                    </span>
                    <p class="mb-0 pt-1 f-13">{{ 'useraccount.managephoto' | trans }}</p>
                </a>
              </div>
              <!-- <div class="col-3 col-sm-2 col-md text-center p-1">
                <a class="cursor-pointer opacity" matTooltip="Manage Photo" matTooltipPosition="above"
                data-toggle="modal" data-target="#settingsaccessibilitymodal">
                  <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
                    settings_accessibility
                    </span>
                    <p class="mb-0 pt-1 f-13">Accessibility</p>
                </a>
              </div> -->
              <!-- <div class="col-3 col-sm-2 col-md text-center p-1">
                <a class="cursor-pointer opacity" matTooltip="Show Orglist" matTooltipPosition="above"
                data-toggle="collapse" data-target="#personorglist">
                  <span class="material-icons bg-lightgrey p-2 f-24 cursor-pointer rounded-circle text-secondary zoom">
                    list
                    </span>
                    <p class="mb-0 pt-1 f-13">Show organizations</p>
                </a>
              </div> -->
              <div class="col-3 col-sm-2 col-md text-center p-1">
                <a data-toggle="modal" data-target="#settingsModal"  
                  class="cursor-pointer opacity" matTooltip="{{ 'useraccount.settingstip' | trans }}" matTooltipPosition="above">
                  <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle cursor-pointer text-secondary zoom">
                    settings
                    </span>
                    <p class="mb-0 pt-1 f-13">{{ 'useraccount.settings' | trans }}</p>
                </a>
              </div>
              <div class="col-3 col-sm-2 col-md text-center p-1">
                <a target="_blank" rel="noopener noreferrer" href="https://app.clearramp.com/support"
                  class="cursor-pointer opacity" matTooltip="{{ 'useraccount.support' | trans }}"support matTooltipPosition="above">
                  <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle cursor-pointer text-secondary zoom">
                    help_center
                    </span>
                    <p class="mb-0 pt-1 f-13">{{ 'useraccount.support' | trans }}</p>
                </a>
              </div>
              <div class="col-3 col-sm-2 col-md text-center p-1">
                <a class="cursor-pointer opacity" matTooltip="{{ 'useraccount.privacypolicy' | trans }}" matTooltipPosition="above"
                href="https://www.clearramp.com/privacy">
                  <span class="zoom bg-lightgrey p-2 f-24 rounded-circle text-secondary material-icons">
                    policy
                    </span>
                    <p class="mb-0 pt-1 f-13">{{ 'useraccount.privacypolicy' | trans }}</p>
                </a>
              </div>
              <div class="col-3 col-sm-2 col-md text-center p-1">
                <a class="cursor-pointer opacity" matTooltip="{{ 'useraccount.termsofuse' | trans }}" matTooltipPosition="above"
                href="https://www.clearramp.com/terms">
                  <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
                    gavel
                  </span>
                  <p class="mb-0 pt-1 f-13">{{ 'useraccount.termsofuse' | trans }}</p>
                </a>
              </div>
            </div>
          </div> 
          <div class="">
            <p class="mt-2 text-muted">Current version - 1.2.9</p>
          </div>
          <div class="spacer"></div>
        </div>  
        <!-- <div class="row collapse mr-0 ml-0 mt-2" id="personorglist"> 
            <div class="col"><app-personorglist></app-personorglist></div>
        </div> -->
    
<!-- Person Modal -->
<div class="modal fade" id="personeditmodal" tabindex="-1" role="dialog" aria-labelledby="personeditmodalCenterTitle" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'useraccount.editinformation' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding:0px;">
        <app-person [modal]="true" [saveperson]="saveperson" ></app-person>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'useraccount.close' | trans }}</p></button>
        <button (click)="savepersonclick()" type="button" class="btn-save" data-dismiss="modal"><p class="btn-save-text">{{ 'useraccount.save' | trans }}</p></button>
      </div>
    </div>
  </div>
</div>

<!-- Person Photo Modal -->
<div class="modal fade" id="personphotomodal" tabindex="-1" role="dialog" aria-labelledby="personphotomodalCenterTitle" >

        <app-personimage [bigimg]="true" [enableChange]="true" [personId]="personId"></app-personimage>
</div>

<!-- Modal SETTING -->
<div class="modal fade" id="settingsModal" tabindex="-1" role="dialog" aria-labelledby="Org Settings" >
  <app-usersettings></app-usersettings>
</div>

  <!---settings accessibility Modal-->
<!-- <div class="modal fade" id="settingsaccessibilitymodal" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Accessibility settings</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Here you can manage your accessibility settings.</p>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
          <label class="form-check-label" for="inlineCheckbox1"><p class="mb-0">Enable Color blind mode</p></label>
        </div> 
        <p class="text-muted">Enabling color blind mode will display icons to better communicate the state and status of a given project.</p>
      <!-- <div class="border w-100"></div> -->
       <!-- </div>
      <div class="modal-footer">
        <div class="btn-close" data-dismiss="modal" aria-label="Close"><p class="btn-save-text text-center">Close</p></div>

        <div class="btn-save"><p class="btn-save-text text-center">Save changes</p></div>
      </div>
    </div>
  </div>
</div> -->